import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface SubScribeInfo {
  hasPay: boolean ;
  paidRoomId: string;
}

const subScribeInfo: StateCreator< SubScribeInfo, [
  ['zustand/immer', never],
]> = () => ({
  hasPay: false,
  paidRoomId: '',
});
const useSubScribeStore: UseBoundStore<StoreApi<SubScribeInfo>> = create<SubScribeInfo>()(immer(subScribeInfo));
export default useSubScribeStore;

/**
 * 更新用户最新是否支付
 * @param val 是否支付成功
 * @param roomId 本次支付关联的房间 ID
 */
export const setHasPay = (val: boolean, roomId?: string) => {
  useSubScribeStore.setState({
    hasPay: val,
    paidRoomId: val ? roomId || '' : '',
  });
};
